import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SkipLink from "./components/SkipLink";
import Home from "./pages/Home";
import Solution from "./pages/Solution";
import Offres from "./pages/Offres";
import Exemples from "./pages/Exemples";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import Confidentialite from "./pages/Confidentialite";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";

// Admin pages
import { AuthProvider, useAuth } from "./context/AuthContext";
import ScrollToTop from "./components/ScrollToTop";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPosts from "./pages/admin/AdminPosts";
import AdminPostEditor from "./pages/admin/AdminPostEditor";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminNewsletters from "./pages/admin/AdminNewsletters";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-700"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/gestion-x7k9p2/login" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><Home /></main>
                <Footer />
              </>
            } />
            <Route path="/solution" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><Solution /></main>
                <Footer />
              </>
            } />
            <Route path="/offres" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><Offres /></main>
                <Footer />
              </>
            } />
            <Route path="/exemples" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><Exemples /></main>
                <Footer />
              </>
            } />
            <Route path="/blog" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><Blog /></main>
                <Footer />
              </>
            } />
            <Route path="/blog/:slug" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><BlogPost /></main>
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><Contact /></main>
                <Footer />
              </>
            } />
            <Route path="/mentions-legales" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><MentionsLegales /></main>
                <Footer />
              </>
            } />
            <Route path="/confidentialite" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><Confidentialite /></main>
                <Footer />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/gestion-x7k9p2/login" element={<AdminLogin />} />
            <Route path="/gestion-x7k9p2/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/gestion-x7k9p2/posts" element={
              <ProtectedRoute>
                <AdminPosts />
              </ProtectedRoute>
            } />
            <Route path="/gestion-x7k9p2/posts/new" element={
              <ProtectedRoute>
                <AdminPostEditor />
              </ProtectedRoute>
            } />
            <Route path="/gestion-x7k9p2/posts/edit/:id" element={
              <ProtectedRoute>
                <AdminPostEditor />
              </ProtectedRoute>
            } />
            <Route path="/gestion-x7k9p2/contacts" element={
              <ProtectedRoute>
                <AdminContacts />
              </ProtectedRoute>
            } />
            <Route path="/gestion-x7k9p2/newsletters" element={
              <ProtectedRoute>
                <AdminNewsletters />
              </ProtectedRoute>
            } />

            {/* Catch-all : toute URL inconnue affiche une page 404 */}
            <Route path="*" element={
              <>
                <SkipLink />
                <Header />
                <main id="main-content"><NotFound /></main>
                <Footer />
              </>
            } />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
